/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface DeleteClassResponse
 */
export interface DeleteClassResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof DeleteClassResponse
     */
    id: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof DeleteClassResponse
     */
    name: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DeleteClassResponse
     */
    deletedItems: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DeleteClassResponse
     */
    entityId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeleteClassResponse
     */
    displayName?: string | null;
}

/**
 * Check if a given object implements the DeleteClassResponse interface.
 */
export function instanceOfDeleteClassResponse(value: object): value is DeleteClassResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('deletedItems' in value) || value['deletedItems'] === undefined) return false;
    return true;
}

export function DeleteClassResponseFromJSON(json: any): DeleteClassResponse {
    return DeleteClassResponseFromJSONTyped(json, false);
}

export function DeleteClassResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteClassResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetPageParameterFromJSON(json['id']),
        'name': json['name'],
        'deletedItems': json['deletedItems'],
        'entityId': json['entityId'] == null ? undefined : json['entityId'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
    };
}

export function DeleteClassResponseToJSON(json: any): DeleteClassResponse {
    return DeleteClassResponseToJSONTyped(json, false);
}

export function DeleteClassResponseToJSONTyped(value?: DeleteClassResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetPageParameterToJSON(value['id']),
        'name': value['name'],
        'deletedItems': value['deletedItems'],
        'entityId': value['entityId'],
        'displayName': value['displayName'],
    };
}

